export const VALUATION_INPUT_DEBOUNCE_MS = 1000;
